import { AccessedOrganizerNotificationBody, ClientInformationBody, ClientManagementTestConnectionBody, DocumentSignedBody, DocumentSignedTestConnectionBody, DownloadDrlDocumentBody, DownloadDrlDocumentTestConnectionBody, DownloadESignedDocumentBody, DownloadSourceDocumentsBody, EngagementLetterSignedAndOrganizerCompletedBody, GTR_CommonBody, GTR_TestConnectionBody, QuestionnaireCompletedBody, ReturnStatusChange, SSOTestConnectionBody, SignatureStatusChange as SignatureStatusChangeBody, SourceDocumentUploadedBody } from "../../common/model/webhookResponse";
import { GTR_commonParameter, GTR_downloadSourceDocumentsParameter, SIG_DocumentSignedParameter, SSE_downloadDrlDocumentParameter, SSR_DownloadEsignedDocumentParameter, SSR_ReturnStatusChangeParameter, SUITE_ClientManagement_DocumentSignedParameter, accessedOrganizerNotificationParameter, commonParameters, engagementLetterSignedAndOrganizerCompletedParameter, eventTypesParameter, questionnaireCompletedParameter, sourceDocumentUploadedParameter } from "./webhookParameters";


const eventTypeObject = {
    eventType0: eventTypesParameter.eventType0,
    eventType1000: eventTypesParameter.eventType1000,
    eventType1001: eventTypesParameter.eventType1001,
    eventType2000: eventTypesParameter.eventType2000,
    eventType2001: eventTypesParameter.eventType2001,
    eventType2002: eventTypesParameter.eventType2002,
    eventType2003: eventTypesParameter.eventType2003,
    eventType3000: eventTypesParameter.eventType3000,
    eventType3001: eventTypesParameter.eventType3001,
    eventType4000: eventTypesParameter.eventType4000,
    eventType5001: eventTypesParameter.eventType5001,
    eventType6000: eventTypesParameter.eventType6000,
    eventType6001: eventTypesParameter.eventType6001,
    eventType6002: eventTypesParameter.eventType6002,
}

export const documentSignedTestConnectionBody: DocumentSignedTestConnectionBody = {
    eventType0: eventTypeObject.eventType0,
    eventType3000: eventTypeObject.eventType3000,
    eventType3001 :eventTypeObject.eventType3001
};

export const documentSignedBody: DocumentSignedBody = {
    clientId: SIG_DocumentSignedParameter.clientId,
    clientName: SIG_DocumentSignedParameter.clientName,
    taxYear: commonParameters.taxYear,
    sentBy: SIG_DocumentSignedParameter.sentBy,
    totalRecipients: SIG_DocumentSignedParameter.totalRecipients,
    recipientList: SIG_DocumentSignedParameter.recipientList,
    delegateeList: SIG_DocumentSignedParameter.delegateeList,
    signatureStatus: SIG_DocumentSignedParameter.signatureStatus,
    uniqueArgs: SIG_DocumentSignedParameter.uniqueArgs,
    signedFilesFileName: SIG_DocumentSignedParameter.signedFilesFileName,
    signedFilesSasUrl: SIG_DocumentSignedParameter.signedFilesSasUrl,
    signedFilesDocumentType: SIG_DocumentSignedParameter.signedFilesDocumentType,
    signedFilesDocumentGuid: SIG_DocumentSignedParameter.signedFilesDocumentGuid,
    signedFilesDocumentId: SIG_DocumentSignedParameter.signedFilesDocumentId,
    signedFilesExpiresOn: SIG_DocumentSignedParameter.signedFilesExpiresOn
};
export const signatureStatusChangeBody : SignatureStatusChangeBody = 
{
    clientId : SIG_DocumentSignedParameter.clientId,
    clientName : SIG_DocumentSignedParameter.clientName,
    documentId : SIG_DocumentSignedParameter.documentId,
    documentType : SIG_DocumentSignedParameter.documentType,
    officeLocation : SIG_DocumentSignedParameter.officeLocation,
    sentBy : SIG_DocumentSignedParameter.sentBy,
    signatureId : SIG_DocumentSignedParameter.signatureId,
    status  : SIG_DocumentSignedParameter.signatureStatus,
    statusDate : SIG_DocumentSignedParameter.statusDate,
    taxYear : SIG_DocumentSignedParameter.taxYear,
    totalRecipients : SIG_DocumentSignedParameter.totalRecipients,
    uniqueArgs : SIG_DocumentSignedParameter.uniqueArgs
}

export const signatureStatusChangeTestConnectionBody: DocumentSignedTestConnectionBody = {
    eventType0: eventTypeObject.eventType0,
    eventType3000: eventTypeObject.eventType3000,
    eventType3001: eventTypeObject.eventType3000
};

export const gtr_TestConnectionBody: GTR_TestConnectionBody = {
    eventType0: eventTypeObject.eventType0,
    eventType6000: eventTypeObject.eventType6000,
    eventType6001: eventTypeObject.eventType6001,
    eventType6002: eventTypeObject.eventType6002
};

export const GTR_commonBody: GTR_CommonBody = {
    gatherId: GTR_commonParameter.gatherId,
    taxpayerName: GTR_commonParameter.taxpayerName,
    spouseName: GTR_commonParameter.spouseName,
    clientId: GTR_commonParameter.clientId,
    taxpayerEmail: commonParameters.taxPayerEmail,
    spouseEmail: GTR_commonParameter.spouseEmail,
    taxYear: commonParameters.taxYear,
    eroSigner: commonParameters.eroSigner,
    assignedTo: commonParameters.assignedTo,
    uniqueArgs: GTR_commonParameter.uniqueArgs,
    documentFileFileName: commonParameters.documentFileFileName,
    documentFileSasUrl: commonParameters.documentFileSasUrl
};

export const downloadEsignDocumentsBody = {
    ...GTR_commonBody
};

export const downloadFillableOrganizerBody = {
    ...GTR_commonBody
};

export const downloadSourceDocumentsBody: DownloadSourceDocumentsBody = {
    gatherId: GTR_commonBody.gatherId,
    clientId: GTR_commonParameter.clientId,
    clientName: GTR_downloadSourceDocumentsParameter.clientName,
    taxpayerEmail: GTR_commonBody.taxpayerEmail,
    assignedTo: GTR_commonBody.assignedTo,
    eroSigner: GTR_commonBody.eroSigner,
    engagementType: commonParameters.engagementType,
    taxYear: GTR_commonBody.taxYear,
    batchName: commonParameters.batchName,
    spouseName: GTR_commonBody.spouseName,
    spouseEmail: GTR_commonBody.spouseEmail,
    uniqueArgs: GTR_commonParameter.uniqueArgs,
    documentFileFileName: GTR_commonBody.documentFileFileName,
    documentFileSasUrl: GTR_commonBody.documentFileSasUrl
};

export const SUITE_ClientManagement_DocumentSignedBody: ClientInformationBody = {
    uId: SUITE_ClientManagement_DocumentSignedParameter.uId,
    clientId: SUITE_ClientManagement_DocumentSignedParameter.clientId,
    ero: SUITE_ClientManagement_DocumentSignedParameter.ero,
    location: SUITE_ClientManagement_DocumentSignedParameter.location,
    type: SUITE_ClientManagement_DocumentSignedParameter.clientType,
    mfj: SUITE_ClientManagement_DocumentSignedParameter.mfj,
    actionDate: SUITE_ClientManagement_DocumentSignedParameter.actionDate,
    actionType: SUITE_ClientManagement_DocumentSignedParameter.actionType,
    name: SUITE_ClientManagement_DocumentSignedParameter.name,
    email: SUITE_ClientManagement_DocumentSignedParameter.email,
    mobile: SUITE_ClientManagement_DocumentSignedParameter.mobile,
    countryCode: SUITE_ClientManagement_DocumentSignedParameter.countryCode,
    ssn: SUITE_ClientManagement_DocumentSignedParameter.ssn
};

export const downloadDrlDocumentTestConnectionBody: DownloadDrlDocumentTestConnectionBody = {
    eventType0: eventTypeObject.eventType0,
    eventType4000: eventTypeObject.eventType4000
};

export const downloadDrlDocumentBody: DownloadDrlDocumentBody = {
    documentRequestListId: SSE_downloadDrlDocumentParameter.documentRequestListId,
    clientEmailId: SSE_downloadDrlDocumentParameter.clientEmailId,
    documentFieldName: SSE_downloadDrlDocumentParameter.documentFieldName,
    uploadedDate: SSE_downloadDrlDocumentParameter.uploadedDate,
    documentName: SSE_downloadDrlDocumentParameter.documentName,
    documentSasUrl: SSE_downloadDrlDocumentParameter.documentSasUrl,
    uniqueArgs: SSE_downloadDrlDocumentParameter.uniqueArgs
};

export const ssoTestConnectionBody: SSOTestConnectionBody = {
    eventType0: eventTypeObject.eventType0,
    eventType2000: eventTypeObject.eventType4000,
    eventType2001: eventTypeObject.eventType4000,
    eventType2002: eventTypeObject.eventType4000,
    eventType2003: eventTypeObject.eventType4000
};

export const clientManagementTestConnectionBody: ClientManagementTestConnectionBody = {
    eventType0: eventTypeObject.eventType0,
    eventType5001: eventTypeObject.eventType5001
};

export const engagementLetterSignedAndOrganizerCompletedBody: EngagementLetterSignedAndOrganizerCompletedBody = {
    taxPayerName: commonParameters.taxPayerName,
    clientId: engagementLetterSignedAndOrganizerCompletedParameter.clientId,
    taxPayerEmail: commonParameters.taxPayerEmail,
    taxYear: commonParameters.taxYear,
    eroSigner: commonParameters.eroSigner,
    assignedTo: commonParameters.assignedTo,
    uniqueArgs: engagementLetterSignedAndOrganizerCompletedParameter.uniqueArgs,
    documentName: commonParameters.documentFileFileName,
    documentSasUrl: commonParameters.documentFileSasUrl,
    documentGuid: commonParameters.documentGuid,
    organizerId: commonParameters.organizerId
};

export const sourceDocumentUploadedBody: SourceDocumentUploadedBody = {
    taxPayerName: commonParameters.taxPayerName,
    clientId: sourceDocumentUploadedParameter.clientId,
    taxPayerEmail: commonParameters.taxPayerEmail,
    taxYear: commonParameters.taxYear,
    eroSigner: commonParameters.eroSigner,
    assignedTo: commonParameters.assignedTo,
    uniqueArgs: sourceDocumentUploadedParameter.uniqueArgs,
    documentName: commonParameters.documentFileFileName,
    documentSasUrl: commonParameters.documentFileSasUrl,
    uploadedOn: sourceDocumentUploadedParameter.uploadedOn,
    documentGuid: commonParameters.documentGuid,
    organizerId: commonParameters.organizerId
};

export const accessedOrganizerNotificationBody: AccessedOrganizerNotificationBody = {
    taxPayerName: commonParameters.taxPayerName,
    clientId: accessedOrganizerNotificationParameter.clientId,
    taxPayerEmail: commonParameters.taxPayerEmail,
    taxYear: commonParameters.taxYear,
    batchName: commonParameters.batchName,
    accessedOn: accessedOrganizerNotificationParameter.accessedOn,
    uniqueArgs: accessedOrganizerNotificationParameter.uniqueArgs,
    organizerId: commonParameters.organizerId
};

export const questionnaireCompletedBody: QuestionnaireCompletedBody = {
    taxPayerName: commonParameters.taxPayerName,
    clientId: questionnaireCompletedParameter.clientId,
    taxPayerEmail: commonParameters.taxPayerEmail,
    taxYear: commonParameters.taxYear,
    eroSigner: commonParameters.eroSigner,
    assignedTo: commonParameters.assignedTo,
    uniqueArgs: questionnaireCompletedParameter.uniqueArgs,
    documentName: commonParameters.documentFileFileName,
    documentSasUrl: commonParameters.documentFileSasUrl,
    documentGuid: commonParameters.documentGuid,
    organizerId: commonParameters.organizerId
};

export const downloadESignedDocumentBody: DownloadESignedDocumentBody = {
    documentId: SSR_DownloadEsignedDocumentParameter.documentId,
    documentGuid: SSR_DownloadEsignedDocumentParameter.documentGuid,
    documentStatus: SSR_DownloadEsignedDocumentParameter.documentStatus,
    signatureStatus: SSR_DownloadEsignedDocumentParameter.signatureStatus,
    signedOn: SSR_DownloadEsignedDocumentParameter.signedOn,
    taxSoftware: SSR_DownloadEsignedDocumentParameter.taxSoftware,
    deliveredOn: SSR_DownloadEsignedDocumentParameter.deliveredOn,
    taxYear: commonParameters.taxYear,
    engagementType: commonParameters.engagementType,
    documentClientsClientType: SSR_DownloadEsignedDocumentParameter.documentClientsClientType,
    documentClientsName: SSR_DownloadEsignedDocumentParameter.documentClientsName,
    documentClientsEmail: SSR_DownloadEsignedDocumentParameter.documentClientsEmail,
    documentClientsSSN: SSR_DownloadEsignedDocumentParameter.documentClientsSsn,
    signedFilesFileName: SSR_DownloadEsignedDocumentParameter.signedFilesFileName,
    signedFilesFileSAS: SSR_DownloadEsignedDocumentParameter.signedFilesFileSas,
    additionalEsignedFilesFileName: SSR_DownloadEsignedDocumentParameter.additionalEsignedFilesFileName,
    additionalEsignedFilesFileSAS: SSR_DownloadEsignedDocumentParameter.additionalEsignedFilesFileSas,
    clientId: SSR_DownloadEsignedDocumentParameter.clientId,
    httpStatus: commonParameters.httpStatus,
    message: SSR_DownloadEsignedDocumentParameter.message,
    uniqueArgs: SSR_DownloadEsignedDocumentParameter.uniqueArgs,
    taxReturnId: commonParameters.taxReturnId
};

export const returnStatusChangeBody: ReturnStatusChange = {
    Status: SSR_ReturnStatusChangeParameter.status,
    statusDate: SSR_ReturnStatusChangeParameter.statusDate,
    eroEmail: SSR_ReturnStatusChangeParameter.eroEmail,
    assignedEmail: SSR_ReturnStatusChangeParameter.assignedEmail,
    formType: SSR_ReturnStatusChangeParameter.formType,
    taxYear: commonParameters.taxYear,
    taxReturnId: commonParameters.taxReturnId,
    documentGuid: SSR_DownloadEsignedDocumentParameter.documentGuid,
    documentId: SSR_ReturnStatusChangeParameter.documentId,
    clientId: SSR_ReturnStatusChangeParameter.clientId,
    httpStatus: commonParameters.httpStatus,
    uniqueArgs: SSR_ReturnStatusChangeParameter.uniqueArgs,
};